import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Super Admin Module - Organization Management
 *
 * Platform-level administration for managing organizations.
 * Accessible only to users with the super_admin global role.
 */
const superAdminModule: AppModule = {
    id: 'super-admin',
    navigation: {
        label: 'Super Admin',
        icon: 'zap',
        path: '/super-admin/organizations',
        order: 100, // Show at bottom of sidebar
        showInSidebar: false, // Hidden - Organizations is now its own module under Settings
        pages: [
            {
                label: 'All Organizations',
                path: '/super-admin/organizations',
                icon: 'building-2',
            },
            {
                label: 'Add Organization',
                path: '/super-admin/organizations/create',
                icon: 'building-plus',
            },
        ],
    },
    routes,
}

export default superAdminModule
